import type { SubscriptionPlan } from '@/types/dtos/transactions/subscription-plan.dto';
import { defaultMainSubscriptionProductKeyForCategory } from '@/helpers/organization-plan-catalog';
import type { OrganizationSubscriptionInstanceDto } from '@/types/dtos/organizations/organization-subscription-instance.dto';

const HOST_DEFAULT_PRODUCT_KEY = defaultMainSubscriptionProductKeyForCategory('HOST');

/** Primary host bundle row, or first Organization-scoped instance. */
export function getPrimaryOrganizationSubscriptionInstance(
  org: { subscriptions?: OrganizationSubscriptionInstanceDto[] } | undefined,
): OrganizationSubscriptionInstanceDto | undefined {
  if (!org?.subscriptions?.length) {
    return undefined;
  }
  return (
    org.subscriptions.find((s) => s.subscriptionProductKey === HOST_DEFAULT_PRODUCT_KEY) ??
    org.subscriptions.find((s) => s.entityType === 'Organization') ??
    org.subscriptions[0]
  );
}

/** Shape shared by legacy `Subscription` and embedded instances for plan UI. */
export function subscriptionPlanSnapshotFromOrg(org: {
  subscriptions?: OrganizationSubscriptionInstanceDto[];
}): SubscriptionPlan | undefined {
  const inst = getPrimaryOrganizationSubscriptionInstance(org);
  return inst?.subscriptionPlan as SubscriptionPlan | undefined;
}
